<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="series">
<p class="sert">Books by Ralph Peters</p>
<p class="serah">Nonfiction</p>
<p class="ser">Endless War</p>
<p class="ser">Looking for Trouble</p>
<p class="ser">Wars of Blood and Faith</p>
<p class="ser">New Glory</p>
<p class="ser">Never Quit the Fight</p>
<p class="ser">Beyond Baghdad</p>
<p class="ser">Beyond Terror</p>
<p class="ser">Fighting for the Future</p>
<p class="serah" style="margin-top: 1em;">Fiction</p>
<p class="ser">The Officers’ Club</p>
<p class="ser">The War After Armageddon</p>
<p class="ser">Traitor</p>
<p class="ser">The Devil’s Garden</p>
<p class="ser">Twilight of Heroes</p>
<p class="ser">The Perfect Soldier</p>
<p class="ser">Flames of Heaven</p>
<p class="ser">The War in 2020</p>
<p class="ser">Red Army</p>
<p class="ser">Bravo Romeo</p>
<p class="sers">Writing as Owen Parry</p>
<p class="serah">Fiction</p>
<p class="ser">Rebels of Babylon</p>
<p class="ser">Bold Sons of Erin</p>
<p class="ser">Honor’s Kingdom (Hammett Award)</p>
<p class="ser">Call Each River Jordan</p>
<p class="ser">Shadows of Glory</p>
<p class="ser">Faded Coat of Blue (Herodotus Award)</p>
<p class="ser">Our Simple Gifts</p>
<p class="ser">Strike the Harp</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// spblinesoffire0002.vue?cbfa87a0